import * as React from "react";
import moment from "moment";
import styled from "../../lib/styled";
import { Link } from "gatsby";
import { presets } from "../../lib/presets";

interface CountdownProps {
  date?: string;
  image?: string;
  text: string;
  linkUrl?: string;
  linkText?: string;
}

const InlineCountdown: React.FC<CountdownProps> = (props) => {
  return (
    <SideBarBox image={props.image}>
      <SideBarContent>
        <CountdownDate>
          {Math.abs(
            moment().diff(
              moment(props.date, "YYYY/MM/DD").startOf("day"),
              "days"
            )
          )}
        </CountdownDate>

        <Text>{props.text}</Text>
        {props.linkUrl && (
          <>
            <Separator />
            <GoToLink to={props.linkUrl}>{props.linkText}</GoToLink>
          </>
        )}
      </SideBarContent>
    </SideBarBox>
  );
};

export default InlineCountdown;

const SideBarBox = styled.div<{ image?: string }>`
  width: 100%;
  margin: 10px 0;
  ${presets.mq.max.tablet} {
    width: calc(50% - 10px);
  }

  ${presets.mq.max.mobile} {
    width: 100%;
  }
  max-width: 100%;
  border: 1px solid ${(props) => props.theme.color.accent};
  background-color: ${(props) => props.theme.color.darkFour};
  background: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  position: relative;
  margin-bottom: 15px;
`;

const SideBarContent = styled.div`
  padding: 40px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  color: white;
  z-index: 1;
`;
const CountdownDate = styled.div`
  font-family: "Bebas Neue";
  font-size: 80px;
  line-height: 1em;
`;
const Text = styled.div`
  font-family: "Bebas Neue";
  font-size: 20px;
  line-height: 1em;
`;

const Separator = styled.div`
  margin: 20px 0;
  width: 70px;
  height: 2px;
  background-color: white;
`;

const GoToLink = styled(Link)`
  font-family: "Keep Calm";
  letter-spacing: 1px;
  font-size: 10px;
  color: white;
  text-transform: uppercase;
`;
